module.exports = __webpack_public_path__ + "static/media/по.eba738c0.mp3";